export class ServiceMessage {

    static _el;

    static register(el){
        this._el = el;
    }

    static warn(detail){
        this._el.show({severity: 'warn', summary: 'Aviso!', detail: detail});

    }

    static error(detail){
        this._el.show({severity: 'error', summary: 'Erro!', detail: detail});

    }
}